import {MenuStrategy} from "../MenuStrategy";

export class DispositiviGestioneDispositiviMenuStrategy extends MenuStrategy {
   constructor() {
    super('Gestione Dispositivi', 'Gestione Dispositivi', 'app-devices-management');
  }
}
